import { useTheme } from '@emotion/react';
import { useCallback, useMemo } from 'react';
import { Map } from '@packlink/cartography';
import { useTranslation } from '@packlink/translation-provider';
import { Button, ButtonSize, ButtonColor, ButtonVariant } from '@shipengine/giger';
import { Address } from './list/Row.js';
import { getPudoMapStyles, getPudoMapPanelStyles } from './PudoMapStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

const MapPanel = _ref => {
  let {
    onConfirm,
    active,
    expanded,
    selectedId
  } = _ref;
  const {
    t
  } = useTranslation();
  return jsxs("div", {
    css: getPudoMapPanelStyles,
    children: [jsx(Address, {
      address: active.address,
      businessName: active.businessName,
      id: active.id,
      expanded: expanded
    }), jsx(Button, {
      isFullWidth: true,
      onClick: onConfirm,
      size: ButtonSize.SMALL,
      color: ButtonColor.PRIMARY,
      variant: ButtonVariant.FILLED,
      children: t(active.id === selectedId ? 'pudo.point.confirmed-on-map' : 'pudo.point.confirm-on-map')
    })]
  });
};
const toImapMarker = (id, lat, lng, isTheActiveMarker, customIcon, activeColor) => ({
  id: id.toString(),
  position: {
    lat,
    lng
  },
  icon: isTheActiveMarker ? {
    ...customIcon,
    fillColor: activeColor
  } : customIcon
});
const PudoMap = _ref2 => {
  let {
    dropOffPoints,
    isExpanded,
    active,
    selectedId,
    buyerPoint,
    onConfirm,
    onMapIdle,
    onActivePoint
  } = _ref2;
  const theme = useTheme();
  const onIdle = useCallback(() => onMapIdle === null || onMapIdle === void 0 ? void 0 : onMapIdle(), [onMapIdle]);
  const onActiveMapPoint = useCallback(id => onActivePoint(id), [onActivePoint]);
  const mapPoints = useMemo(() => {
    const CUSTOM_ICON = {
      fillColor: theme.palette.gray.main,
      fillOpacity: 1,
      scale: 1.5,
      strokeWeight: 0,
      path: 'M12,2 C8.13,2 5,5.13 5,9 C5,14.25 12,22 12,22 C12,22 19,14.25 19,9 C19,5.13 15.87,2 12,2 Z M12,11.5 C10.62,11.5 9.5,10.38 9.5,9 C9.5,7.62 10.62,6.5 12,6.5 C13.38,6.5 14.5,7.62 14.5,9 C14.5,10.38 13.38,11.5 12,11.5 Z',
      anchor: {
        x: 12,
        y: 22
      }
    };
    const activeColor = theme.palette.secondary.main;
    return dropOffPoints.map(_ref3 => {
      let {
        id,
        lat,
        lng
      } = _ref3;
      return toImapMarker(id, lat, lng, (active === null || active === void 0 ? void 0 : active.id) === id, CUSTOM_ICON, activeColor);
    }).concat(buyerPoint ? [buyerPoint] : []);
  }, [buyerPoint, dropOffPoints, active, theme]);
  return jsxs("div", {
    css: getPudoMapStyles,
    "data-id": "pudo-google-map",
    children: [jsx(Map, {
      markers: mapPoints,
      onMarkerClick: onActiveMapPoint,
      onIdle: onIdle,
      mapCenterPos: active,
      zoomControl: true
    }), !isExpanded && active && jsx(MapPanel, {
      onConfirm: onConfirm,
      expanded: isExpanded,
      active: active,
      selectedId: selectedId
    })]
  });
};
PudoMap.displayName = 'PudoMap';
var PudoMap$1 = PudoMap;

export { PudoMap$1 as default };
//# sourceMappingURL=PudoMap.js.map
